<sales-ui-slide-out-panel>
  <div content class="pipeline-style">
    <ng-content select="[content]"></ng-content>
  </div>

  <ng-container drawer-content *ngIf="sidePanelState$ | async as sidePanelState">
    <div [ngSwitch]="sidePanelState.state">
      <div id="top-of-sidepanel"></div>
      <sales-ui-opportunity-details
        *ngSwitchCase="SidePanelState.opportunityDetails"
        class="drawer-options"
      ></sales-ui-opportunity-details>
      <sales-ui-create-opportunity *ngSwitchCase="SidePanelState.opportunityCreate"></sales-ui-create-opportunity>
    </div>
  </ng-container>
</sales-ui-slide-out-panel>
